module.exports = __webpack_public_path__ + "static/media/PNImg1.6a40576b.webp";